import { InlineTooltip } from "./InlineTooltip";
export const ClientRadio = ({
  id,
  value,
  label,
  disabled,
  selected,
  onChange = () => {},
  tooltip,
  tooltipDirection
}) => {
  const formatID = `field-radio-${id}`;
  return <div className={`foundry--radiobutton ${disabled ? 'disabled' : ''}`} key={formatID}>
      <input className="radiobutton__input" id={formatID} type="radio" disabled={disabled} value={value} checked={selected == value} onChange={({
      target
    }) => {
      const {
        checked,
        value
      } = target;
      onChange(checked, value);
    }}></input>
      <label className="radiobutton__label" htmlFor={formatID}>
        <span className="radiobutton__label-text">{label}</span>
        {tooltip && <InlineTooltip tooltip={tooltip} icon={faInfoCircle} direction={tooltipDirection} />}
      </label>
    </div>;
};